module.exports = __webpack_public_path__ + "img/ro.1724e0a7.svg";